import React,{useState} from 'react'
import DashboardPart from './DashboardPart/DashboardPart'
import LayoutPart from './LayoutPart/LayoutPart'
import Divider from "@mui/material/Divider";
import CloseIcon from '@mui/icons-material/Close';
import "./OptionsProfile.scss"
import PaletteIcon from '@mui/icons-material/Palette';
import Layout1 from "../../../assets/1.png";
import Layout2 from "../../../assets/2.png";
import Layout3 from "../../../assets/3.png";
import Layout4 from "../../../assets/4.png";
import Layout5 from "../../../assets/5.png";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { GlobalHooks } from '../../../utils/Hooks';
import { useTranslation } from "react-i18next";
import { Check } from '@material-ui/icons';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
export const OptionsProfile = () => {
  const [themeOpen,setThemeOpen] = useState(false)
  const {cookies,setCookie} = GlobalHooks()
  const {t} = useTranslation()
  return (
    <>
    <div className={`Option-Affichage ${cookies.LayoutTheme === "L4" ? "setUpTheWith":""} `}>
        <LayoutPart setThemeOpen={setThemeOpen}/>
        <DashboardPart/>
    </div>
        {themeOpen ? (
          <div className='themeOptionsGlobal'>
            <div onClick={()=>setThemeOpen(false)} className='darkSpaceOptions'>
            </div>
              <div style={{height : cookies.LayoutTheme === "L2" ? "calc(100vh - 134px)" : cookies.LayoutTheme === "L4" ? "100vh" : "calc(100vh - 84px)"}} className='themeBarOptions'>
                <CloseIcon onClick={()=>setThemeOpen(false)} className='close' />
                <div className='part3'>
                  <div className='Blue-Title'>{t("OptionAffichage.couleur de mise en page")} </div>
                  <div className='ColorsSets'>
                    <div className='c1'>
                      <div onClick={()=>setCookie("ColorTheme","default",{path:"/"})} className='boxing'>
                        {cookies.ColorTheme === "default" ? (
                          <CheckCircleRoundedIcon className='checked'/>
                        ):(<></>)}
                        <div className='topBoxColorPalette'>
                          <PaletteIcon className='paletteColor'/>
                        </div>
                        <div className='bottomBoxColorExpample'></div>
                      </div>
                    </div>
                    <div className='c2'>
                      <div onClick={()=>setCookie("ColorTheme","c2",{path:"/"})} className='boxing'>
                      {cookies.ColorTheme === "c2" ? (
                          <CheckCircleRoundedIcon className='checked'/>
                        ):(<></>)}
                        <div className='topBoxColorPalette'>
                          <PaletteIcon className='paletteColor'/>
                        </div>
                        <div className='bottomBoxColorExpample'></div>
                      </div>
                    </div>
                    <div className='c3'>
                      <div onClick={()=>setCookie("ColorTheme","c3",{path:"/"})} className='boxing'>
                        {cookies.ColorTheme === "c3" ? (
                          <CheckCircleRoundedIcon className='checked'/>
                        ):(<></>)}
                        <div className='topBoxColorPalette'>
                          <PaletteIcon className='paletteColor'/>
                        </div>
                        <div className='bottomBoxColorExpample'></div>
                      </div>
                    </div>
                    <div className='c4'>
                      <div onClick={()=>setCookie("ColorTheme","c4",{path:"/"})} className='boxing'>
                        {cookies.ColorTheme === "c4" ? (
                          <CheckCircleRoundedIcon className='checked'/>
                        ):(<></>)}
                        <div className='topBoxColorPalette'>
                          <PaletteIcon className='paletteColor'/>
                        </div>
                        <div className='bottomBoxColorExpample'></div>
                      </div>
                    </div>
                    <div className='c5'>
                      <div onClick={()=>setCookie("ColorTheme","c5",{path:"/"})} className='boxing'>
                        {cookies.ColorTheme === "c5" ? (
                          <CheckCircleRoundedIcon className='checked'/>
                        ):(<></>)}
                        <div className='topBoxColorPalette'>
                          <PaletteIcon className='paletteColor'/>
                        </div>
                        <div className='bottomBoxColorExpample'></div>
                      </div>
                    </div>
                    <div className='c6'>
                      <div onClick={()=>setCookie("ColorTheme","c6",{path:"/"})} className='boxing'>
                        {cookies.ColorTheme === "c6" ? (
                          <CheckCircleRoundedIcon className='checked'/>
                        ):(<></>)}
                        <div className='topBoxColorPalette'>
                          <PaletteIcon className='paletteColor'/>
                        </div>
                        <div className='bottomBoxColorExpample'></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        ):(<></>)}
        </>
  )
}
